import { useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ParticipantsOneDataTable from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

const Participants = () => {
  const context = useOutletContext<DetailOutletContext>()
  const { classes, training, completionConfiguration } = context ?? {}

  if (!context) {
    return (
      <ResponsivePage.Body showHeader={false} loading error={null}>
        {null}
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body showHeader={false} loading={false} error={null}>
      <ParticipantsOneDataTable
        training={training}
        trainingClasses={classes}
        completionConfiguration={completionConfiguration}
        outletContext={context}
      />
    </ResponsivePage.Body>
  )
}

export default Participants
